import { Directive, Injectable, Input, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { ScrollSpyService } from './scroll-watch.service';

@Injectable()
@Directive({
  selector: '[appScrollSpyElement]'
})
export class ScrollSpyElementDirective implements OnInit, OnDestroy {
  @Input() appScrollSpyElement: string;

  private scrollStream$: ReplaySubject<any> = new ReplaySubject(1);

  constructor(private scrollSpy: ScrollSpyService) {}

  @HostListener('scroll', ['$event']) onScroll($event: any) {
    this.scrollStream$.next($event);
  }

  ngOnInit() {
    if (!this.appScrollSpyElement) {
      return console.warn('ScrollSpy: Missing id.');
    }

    if (!!this.scrollSpy.getObservable(this.appScrollSpyElement)) {
      console.warn('ScrollSpy: duplicate id "' + this.appScrollSpyElement + '". Instance will be skipped!');
    } else {
      this.scrollSpy.setObservable(this.appScrollSpyElement, this.scrollStream$);
    }
  }

  ngOnDestroy() {
    this.scrollSpy.deleteObservable(this.appScrollSpyElement);
  }
}



// WEBPACK FOOTER //
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/services/scroll-watch/scroll-watch.directive.ts